import Session from '../core/session'
import Config from '../core/config'

export class PageViewCollector {
  private static instance: PageViewCollector
  private isTracking: boolean = false

  private constructor() {}

  public static getInstance(): PageViewCollector {
    if (!PageViewCollector.instance) {
      PageViewCollector.instance = new PageViewCollector()
    }
    return PageViewCollector.instance
  }

  /**
   * Start tracking page views
   */
  public start(): void {
    if (!Config.get('capturePageViews')) {
      return
    }

    if (this.isTracking) {
      return
    }

    this.isTracking = true

    // Track initial page view
    this.trackPageView()

    // Track page views for SPAs (Single Page Applications)
    this.setupSPATracking()
  }

  /**
   * Track a page view
   */
  private trackPageView(): void {
    Session.trackEvent('pageview', {
      title: document.title,
      url: window.location.href,
      path: window.location.pathname,
      referrer: document.referrer,
      timestamp: new Date().toISOString()
    })

    if (Config.isDebug()) {
      console.log('[RadarSnap] Page view tracked:', window.location.href)
    }
  }

  /**
   * Setup tracking for Single Page Applications
   * Detects URL changes via History API and hash changes
   */
  private setupSPATracking(): void {
    // Track history.pushState
    const originalPushState = history.pushState
    history.pushState = (...args) => {
      originalPushState.apply(history, args)
      this.trackPageView()
    }

    // Track history.replaceState
    const originalReplaceState = history.replaceState
    history.replaceState = (...args) => {
      originalReplaceState.apply(history, args)
      this.trackPageView()
    }

    // Track popstate (back/forward buttons)
    window.addEventListener('popstate', () => {
      this.trackPageView()
    })

    // Track hash changes
    window.addEventListener('hashchange', () => {
      this.trackPageView()
    })
  }

  /**
   * Stop tracking
   */
  public stop(): void {
    this.isTracking = false
  }
}

export default PageViewCollector.getInstance()